let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dh2Er")).then(() => parcelRequire('6TlJn'));